import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/coupon/new',
  title: 'Cadastrar cupom',
  endpoint: '/app/coupon',
}
